import { PILLAR_LABEL_BY_SLUG } from "@/lib/pillars";

const CLASS_MAP = {
  spirituality: "bg-moss/10 text-moss",
  work: "bg-terracotta/10 text-terracotta",
  activities: "bg-[#4A90E2]/10 text-[#4A90E2]",
  sharing: "bg-[#E2A04A]/15 text-[#B27A22]",
};

export default function PillarBadge({ pillar }) {
  const label = PILLAR_LABEL_BY_SLUG[pillar] || pillar;
  return (
    <span
      data-testid={`pillar-badge-${pillar}`}
      className={`pillar-tag ${CLASS_MAP[pillar] || "bg-subtle text-ink"}`}
    >
      {label}
    </span>
  );
}
